// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__11OC3","tick":"tick__y8BBV","tickText":"tickText__1NTF9","isVisible":"isVisible__3jo_Y"};